import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { FaEdit, FaSave, FaTimes, FaLock } from "react-icons/fa";
import { useDataContext } from "../Context/dataContext";
import { Button, Input, Collapse, FormGroup, Label } from "reactstrap";
import Superadminnavbar from "../Components/Superadminnavbar";
import Logo from "../Assets/Images/Logo.jpeg"

function AdmProfile() {
  const { url, infoTkn } = useDataContext();
  const [isEditing, setIsEditing] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [adminId, setAdminId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Obtener datos del administrador
  const fetchAdminData = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/Auth/findByJWTSuperAdmin/${infoTkn}`, {
        headers: { Authorization: `Bearer ${infoTkn}` },
      });

      const adminData = response.data.data;
      setAdminId(adminData.sadm_id);
    } catch (error) {
      console.error("Error obteniendo datos del administrador:", error);
    }
  }, [url, infoTkn]);

  useEffect(() => {
    fetchAdminData();
  }, [fetchAdminData]);


  // Guardar cambios (imagen y/o contraseña)
  const handleSaveChanges = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    // Validación de contraseñas
    if (newPassword && newPassword !== confirmPassword) {
      setErrorMessage("Las contraseñas no coinciden.");
      return;
    }

    try {
      if (newPassword) {
        await axios.put(
          `${url}/SuperAdmin/password/${adminId}`,
          { sadm_password: newPassword },
          { headers: { Authorization: `Bearer ${infoTkn}` } }
        );
      }

      setSuccessMessage("Cambios guardados con éxito.");
      setIsEditing(false);
      window.location.reload();
    } catch (error) {
      console.error("Error al actualizar:", error);
      setErrorMessage("Hubo un error al actualizar los datos.");
    }
  };

  return (
    <div><Superadminnavbar/> 
    <div className="profile-container">
      <h2 className="profile-title">Perfil del Administrador</h2>

      {/* Imagen del Administrador */}
      <div className="profile-image-container">
        <img src={Logo} alt="Admin Logo" className="profile-image" />
        <Button className="edit-button" onClick={() => setIsEditing(!isEditing)}>
          <FaEdit /> Editar Perfil
        </Button>
      </div>

      {/* Sección de edición (acordeón) */}
      <Collapse isOpen={isEditing} className="edit-section">
        <FormGroup>
          <Label for="currentPassword"><FaLock /> Contraseña Actual</Label>
          <Input
            type="password"
            id="currentPassword"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Ingrese su contraseña actual"
          />
        </FormGroup>

        <FormGroup>
          <Label for="newPassword"><FaLock /> Nueva Contraseña</Label>
          <Input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Ingrese su nueva contraseña"
          />
        </FormGroup>

        <FormGroup>
          <Label for="confirmPassword"><FaLock /> Confirmar Contraseña</Label>
          <Input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirme su nueva contraseña"
          />
        </FormGroup>

        {/* Mensajes de error o éxito */}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        {/* Botones de acción */}
        <div className="edit-buttons">
          <Button color="success" onClick={handleSaveChanges}><FaSave /> Guardar Cambios</Button>
          <Button color="danger" onClick={() => setIsEditing(false)}><FaTimes /> Cancelar</Button>
        </div>
      </Collapse>
    </div>
    </div>
  );
}

export  {AdmProfile};
